import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-text-width-icon',
  templateUrl: './text-text-width.component.html'
})
export class TextTextWidthComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
